import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FrameState } from '@store/reducers/frame.reducer';
import { celKey } from '@models/frame.model';

export const selectFrameState = createFeatureSelector<FrameState>('frames');

export const selectAllFrames    = createSelector(selectFrameState, s => s.frames);
export const selectCurrentFrameId = createSelector(selectFrameState, s => s.currentFrameId);
export const selectLayers       = createSelector(selectFrameState, s => s.layers);
export const selectCels         = createSelector(selectFrameState, s => s.cels);
export const selectActiveLayerId = createSelector(selectFrameState, s => s.activeLayerId);

export const selectCurrentFrame = createSelector(
  selectAllFrames, selectCurrentFrameId,
  (frames, id) => frames.find(f => f.id === id) ?? frames[0] ?? null
);

export const selectFrameCount = createSelector(selectAllFrames, frames => frames.length);

export const selectCurrentFrameIndex = createSelector(
  selectAllFrames, selectCurrentFrameId,
  (frames, id) => frames.findIndex(f => f.id === id)
);

export const selectFramesIsLoading = createSelector(selectFrameState, s => s.isLoading);
export const selectCanUndo = createSelector(selectFrameState, s => (s.past?.length ?? 0) > 0);
export const selectCanRedo = createSelector(selectFrameState, s => (s.future?.length ?? 0) > 0);

export const selectActiveLayer = createSelector(
  selectLayers, selectActiveLayerId,
  (layers, id) => layers.find(l => l.id === id) ?? layers[layers.length - 1] ?? null
);

/** All layers – same as selectLayers, kept as alias for old consumers. */
export const selectCurrentFrameLayers = selectLayers;

/** Pixels of the active layer's cel on the current frame (may be undefined = empty cel). */
export const selectActiveCelPixels = createSelector(
  selectCels, selectCurrentFrameId, selectActiveLayerId,
  (cels, frameId, layerId) => {
    if (!frameId || !layerId) return undefined;
    return cels[celKey(frameId, layerId)];
  }
);
